<template>
    <div slot="no-body" class="border-0 shadow-none border-solid border-1 md:w-2/3 lg:w-full" cardBackground="">

      <div class="text-center lg:mx-8 my-2">
      	<div class="font-bold">Are you ready to unleash your inner superhero?</div>

        A year is all it takes to bid farewell to your old ways and welcome a refreshed version of yourself, let's call it yourself 2.0

      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      // Component data here
    }
  },
  methods: {
    // Component methods here
  },
  computed: {
    // Computed properties here
  },
  mounted() {
    // Code that runs when the component is mounted to the DOM
  }
}
</script>
